<template>
  <center-popup class="qr-code-popup"
                :show.sync="visible"
                :title="title"
                :size="size"
                :header-bg="headerBg"
                popup-bg="#fff"
                :close-on-click-overlay="closeOnClickOverlay"
                @closeCenterPopup="closeCenterPopup"
  >
    <div class="qr-code-container"
         :class="{ 'size-small': size === 'small' }"
    >
      <div class="qr-code">
        <ym-img class="img"
                :src="src"
                alt="二维码"
        />
      </div>
      <div class="qr-code-hint" v-html="hintDesc"></div>
      <slot></slot>
    </div>
  </center-popup>
</template>

<script>
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'QrCodePopup',
    components: {
      CenterPopup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
        default: false,
      },
      title: {
        type: String,
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
      src: {
        type: String,
        required: true,
      },
      hint: {
        type: String,
      },
      size: {
        type: String,
        default: 'middle',
      },
      headerBg: {
        type: String,
        default: '#fff',
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    computed: {
      hintDesc() {
        return this.hint.replace(/\n/g, '<br>');
      },
    },
    methods: {
      closeCenterPopup() {
        this.$emit('closeQrCodePopup');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .qr-code-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: @font-size-extra-extra-small;
  }

  .qr-code-container {
    box-sizing: content-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: @size-large 0;

    &.size-small {
      padding: @size-extra-large 0 @size-medium 0;
    }
  }

  .qr-code {
    width: 300px;
    height: 300px;
    border: @border-base;
    .img {
      width: 100%;
      height: 100%;
    }
  }

  .qr-code-hint {
    margin-top: @size-base;
    color: @color-text-base;
    font-size: @font-size-medium;
    line-height: 1.4;
    font-weight: @font-weight-primary;
  }
</style>
